// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__33-U7","chevronRight":"Chevron_chevronRight__CLgW6","chevronLeft":"Chevron_chevronLeft__o3XA9","open":"Chevron_open__301Cn"};